export enum PartnerTypes {
  AG = 1,
  AREA = 2,
  /** Generalvertreter */
  GeneralAgent = 3,
  ServicePartner = 4,
  EndCustomer = 5,
  Supplier = 6,
}
